import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import {arrayObject} from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Configs from "services/ConfigHost"

import Auth from "auth"
import { thaiBath } from "helpers/ConvertFormat"
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsProjectUpdate } from "store/actions"

import * as Alert from "alertService"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit" 
import FilterListIcon from "@material-ui/icons/FilterList"
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

// core components 
import ReactTable from "react-table"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import FileConfigUploadSingle from "components/CustomUpload/FileConfigUploadSingle"
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  },
  mb4: {
    marginBottom: "20px"
  }
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataList:[],

      _id:null, 
      filePath:"",
      originalFileName: "",
      description: "",
      rowCurrentData:{},  
    }
  }
  componentWillUpdate(nextProps, nextState) {
      if(nextProps.currentData && nextProps.currentData !== nextState.rowCurrentData){
        this.setState({
          rowCurrentData: nextProps.currentData,
          _id:nextProps.currentData._id, 
          description: nextProps.currentData.description,
        })
      }else if(nextProps.currentData === null && this.state._id !== null){
        this.setState({
          rowCurrentData: {},
          _id:null, 
          name: ""
        })
      }
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  handleDownloadExcelFile = () => { 
    document.location = Configs.FILE_PATH + "quality_data.xlsx"
  }
 
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        code: CData.code,
        description: CData.description,
        // userType:(
        //   <div className={this.props.classes.tableH}>
        //     <Badge color={"info"}>{dataUser.user_type_name}</Badge>
        //   </div>),  
      }
    })
  }
  callbackUploadedUrl = (filename,originalFileName)=>{ 
    if(filename !== "quality_data.xlsx"){
      ErrorsCallback('ชื่อไฟล์ต้องเป็น "quality_data.xlsx" เท่านั้น' )
      return
    }
    this.setState({
      filePath:Configs.FILE_PATH +filename,
      originalFileName:originalFileName
    },()=>{
      //เรียกให้ตัวกวาดข้อมูล user ไปสร้างทำงาน
      const dataToSend = { 
      }
      APIPost( UrlServer.URL_POST_IMPORT_QUALITY_DATA_SAVE,dataToSend,(datas)=>{ 
          // Alert.LoadingClose()
          SuccessCallback(datas.message, null, () => { 
            window.location.reload()
          })
      })
    })
  }
  handleChangeCheckbox = e =>{
    this.setState({[e.target.name]:!this.state[e.target.name]})
  }  
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <CloudUploadIcon/>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                 นำ Quality Data เข้าระบบโดยการ Import
                </h4>
              </CardHeader>
              <CardBody>
                <form>  
                  <GridContainer>
                    <GridItem xs={12}> 
                      <Button
                        round
                        color="info"
                        className={classes.mb4}
                        onClick={this.handleDownloadExcelFile}
                      >
                        <CloudDownloadIcon className={classes.icons} />
                        ดึงไฟล์ล่าสุดที่อัพโหลด
                      </Button>
                    </GridItem>
                    <GridItem xs={12}> 
                      *เมื่อเลือกแล้วข้อมูลจะถูกอัพเดทเข้าระบบทันที **ต้องเป็นไฟล์ชื่อ "quality_data.xlsx" และ Sheet ต้องชื่อ "Quality" เท่านั้น
                    </GridItem>
                    <GridItem xs={12}>
                       <FileConfigUploadSingle
                        IsFileStatic = {true}
                        lockFileType = ".xlsx"
                        FilePath = {this.state.filePath}
                        CallbackUploadedUrl = {this.callbackUploadedUrl}
                       />
                    </GridItem>
                  </GridContainer> 
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
function mapStateToProps({ listsProject }) {
  return {
    listsProject: listsProject
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsProjectUpdate }
  )
)(ProjectCreateAndEditManagement)
